import { useInterviewContext } from "../../InterviewContext";
import OtherLanguageSectionPreview from "./OtherLanguageSectionPreview";
import { useTranslation } from "react-i18next";
import "../../../styles/forms.scss";
import DisabledTextArea from "../../../../components/DisabledTextArea";
import "./personalTechSkillsTabPreview.css";

export default function PersonalTechSkillsTabPreview({ interview }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="row skill-language-width">
        <div className="col-4">
          <div className="form-group">
            <h1>{t("Language skills")}</h1>
            <div className="label-wrapper">
              <label>{t("Native Language")}</label>
            </div>
            <select className="form-select" name="motherLanguageId" disabled>
              <option>{interview.motherLanguage}</option>
            </select>
          </div>
        </div>
      </div>
      {interview.otherLanguages.map((otherLang, index) => (
        <OtherLanguageSectionPreview otherLanguage={otherLang} index={index} />
      ))}
      <section className="tech-skills-section">
        <h3>{t("Technical Skills")}</h3>
        <ul className="list-inline  ">
          {interview.technologies &&
            interview.technologies.map((sel) => (
              <li className="list-inline-item m-2" key={sel.id}>
                <span
                  className={`rounded-pill  p-2  skill-bg-${sel.skillType} `}
                >
                  {t(sel.description)}
                </span>
              </li>
            ))}
        </ul>
      </section>
      <div className="row">
        <div className="col-5">
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Other Skills")}</label>
            </div>
            <DisabledTextArea
              name="otherskills"
              value={interview.otherSkills}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-5">
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Skill evaluation")}</label>
            </div>
            <DisabledTextArea
              name="skillEvaluation"
              value={interview.skillEvaluation}
            />
          </div>
        </div>
      </div>
    </>
  );
}
